import React, { useCallback, useState } from "react";
import { useField } from "formik";
import { Flex, ErrorMessage, Text } from "@jsq/ds/core";
import { ClientSelector } from "../../../shared";

interface FormClientSelectorProps {
  selectedArenaName: string;
  onClientSelect: (arenaId: string, arenaName: string) => void;
  fieldName: string;
  placeholder?: string;
}

/**
 * Wrapper around the ClientSelector component that integrates with Formik. Native Formik validation was failing for this component.
 */
export const FormClientSelector: React.FC<FormClientSelectorProps> = ({
  selectedArenaName,
  onClientSelect,
  fieldName,
  placeholder = "Select a client for this payable",
}) => {
  const [, meta, helpers] = useField(fieldName);
  const [hasSelectedClient, setHasSelectedClient] = useState(false);

  const handleClientSelect = useCallback(
    (arenaId: string, arenaName: string) => {
      void helpers.setValue(arenaId);
      void helpers.setTouched(true);
      void helpers.setError(undefined);
      setHasSelectedClient(true);
      onClientSelect(arenaId, arenaName);
    },
    [helpers, onClientSelect],
  );

  const hasError = Boolean(meta.touched && meta.error && !hasSelectedClient);

  return (
    <Flex flexDirection="column" gap={8}>
      <Text variant="strong-md">Client</Text>
      <ClientSelector
        selectedArenaName={selectedArenaName}
        onClientSelect={handleClientSelect}
        placeholder={placeholder}
        error={hasError ? meta.error : ""}
      />
      {hasError && <ErrorMessage>Client is required</ErrorMessage>}
    </Flex>
  );
};
